import $ from 'jquery';
import ScrollOut from 'scroll-out';

export default class CommunityPage {
    constructor() {
        this.scrollOut();
        setTimeout(function () {
            $('[data-community-section-head]').addClass('animate__animated animate__pulse');
        }, 1500);
    }

    scrollOut() {
        ScrollOut({
            targets: "[data-scroll-out]",
            // cssProps: true,
            cssProps: {
                visibleY: true,
                viewportY: true
            },
            onShown: function (el, ctx) {
                // if ($(el).data('scroll-out') === 'content') {
                //     $('[data-community-section-mask]').removeClass('animate__animated animate__fadeOut animate__slow');
                // }
                // console.log(ctx);
            },
            onHidden: function (el) {
                // if ($(el).data('scroll-out') === 'content') {
                //     $('[data-community-section-mask]').addClass('animate__animated animate__fadeOut animate__slow');
                // }
            },
            onChange: function (element, ctx, scrollingElement) {
                /* Triggered when an element changes visibility */
                // console.log(ctx);
            }
        });
    }
};
